import styled, { css } from 'styled-components';
import Icon from '../Icon';
export var ImgWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__ImgWrapper",
  componentId: "sc-9gp46v-0"
})(["display:flex;width:100%;height:100%;"]);
export var Img = /*#__PURE__*/styled.img.withConfig({
  displayName: "style__Img",
  componentId: "sc-9gp46v-1"
})(["display:inherit;box-sizing:border-box;object-fit:cover;width:100%;height:100%;", ";", ";"], function (_ref) {
  var position = _ref.position;
  return position && "object-position: ".concat(position, ";");
}, function (_ref2) {
  var ratio = _ref2.ratio;
  return ratio && css(["position:absolute;height:100%;top:0;left:0;bottom:0;right:0;"]);
});
export var ErrorIcon = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "style__ErrorIcon",
  componentId: "sc-9gp46v-2"
})(["width:50%;height:50%;fill:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.grays.midGray;
});